
/**
 * Declares events to avoid magic strings.
 * TODO: Acually use this :face_with_rolling_eyes:
 */
var VRC = VRC || {};

/**
 * Declares events to avoid magic strings.
 */
VRC.Events = {
	RobEntry: {
		update: "robEntryUpdate",
		remove: "robEntryRemove"
	}
};